import { Navigate } from "react-router-dom";

const ProtectedAddRoute = ({ children }) => {
  const canAdd = localStorage.getItem("canAddNewVideo") === "true";
  return canAdd ? children : <Navigate to="/delivery-app-training-centre" />;
};

export default ProtectedAddRoute;
